module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "container",
    class: _vm.isSuccess === true ? 'success' : 'failure'
  }, [(_vm.isSuccess) ? _c('div', [_c('i', {
    staticClass: "icon successColor"
  }, [_vm._v("")])]) : _vm._e(), _vm._v(" "), (!_vm.isSuccess) ? _c('div', [_c('i', {
    staticClass: "icon failureColor"
  }, [_vm._v("")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tipClass",
    class: _vm.isSuccess === true ? 'successColor' : 'failureTipColor'
  }, [_vm._v(_vm._s(_vm.tip))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bc87624!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/message.vue
// module id = 846
// module chunks = 34